<template>
  <b-row class="active-slider no-gutters">
    <b-col cols="12" md="8">
      <Slider :key="id" :id="id" :images="images" :sliderId="sliderId" :link="link" />
    </b-col>
    <b-col>
      <SliderInfo
        :key="id"
        :id="id"
        :model="model"
        :base="base"
        :brand="brand"
        :make="make"
        :cc="cc"
        :color="color"
        :fuel="fuel"
        :mileage="mileage"
        :cilinders="cilinders"
        :doors="doors"
        :keys="keys"
        :source="source"
        :code="code"
        :transmission="transmission"
        :flags="flags"
      />
    </b-col>
  </b-row>
</template>

<script>
import Slider from "../utils/Slider";
import SliderInfo from "./SliderInfo";

export default {
  name: "ActiveSlider",
  components: {
    Slider,
    SliderInfo
  },
  props: {
    id: {
      type: String,
      default: "0"
    },
    images: {
      type: Array,
      default: function() {
        return [];
      }
    },
    model: {
      type: Number,
      default: 0
    },
    base: {
      type: Number,
      default: 0
    },
    brand: {
      type: String,
      default: ""
    },
    make: {
      type: String,
      default: ""
    },
    cc: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
    },
    fuel: {
      type: String,
      default: ""
    },
    mileage: {
      type: String,
      default: "0"
    },
    cilinders: {
      type: String,
      default: "0"
    },
    doors: {
      type: String,
      default: "0"
    },
    keys: {
      type: String,
      default: ""
    },
    source: {
      type: String,
      default: ""
    },
    code: {
      type: String,
      default: ""
    },
    transmission: {
      type: String,
      default: ""
    },
    flags: {
      type: Object,
      default: function() {
        return {};
      }
    },
    auction: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      sliderId: "active-slider",
      link: ""
    };
  },
  created() {
    this.link = "/partida/" + this.auction + "/" + this.code;
  }
};
</script>

<style lang="scss" scoped></style>
